"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.SubmitButtonWrapper = exports.RepeatButtonWrapper = exports.HandlerButtonsWrapper = exports.Repeater = exports.FormGroup = exports.FormikState = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var FormikState = _styledComponents["default"].div.withConfig({
  displayName: "styles__FormikState"
})(["background-color:#e5e5e5;margin-top:1rem;padding:1rem;"]);

exports.FormikState = FormikState;

var FormGroup = _styledComponents["default"].div.withConfig({
  displayName: "styles__FormGroup"
})(["width:100%;", ";", ";", ";", ";.ant-form-item{margin-bottom:.5rem;}.ant-collapse{margin-top:.25rem;}.ant-collapse-header{min-height:30px;padding-top:.25rem !important;padding-bottom:.25rem !important;}"], function (a) {
  return a.hidden && "\n    display: none;\n  ";
}, function (a) {
  return a.hasError && "\n    .ant-collapse{\n      border: 1px solid red;\n  ";
}, function (a) {
  return a.hasSuccess && "\n    .ant-collapse{\n      border: 1px solid green;\n  ";
}, function (a) {
  return a.hasMargin && "\n    \n    margin-bottom: 2rem;\n  ";
});

exports.FormGroup = FormGroup;

var Repeater = _styledComponents["default"].div.withConfig({
  displayName: "styles__Repeater"
})(["border:2px dotted #d9d9d9;padding:1rem;margin-bottom:0.5rem;position:relative;"]);

exports.Repeater = Repeater;

var HandlerButtonsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__HandlerButtonsWrapper"
})(["position:absolute;display:flex;top:0.5rem;right:0.5rem;button{margin-right:0.5rem;}"]);

exports.HandlerButtonsWrapper = HandlerButtonsWrapper;

var RepeatButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__RepeatButtonWrapper"
})(["text-align:center;"]);

exports.RepeatButtonWrapper = RepeatButtonWrapper;

var SubmitButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__SubmitButtonWrapper"
})(["text-align:right;margin-top:1rem;"]);

exports.SubmitButtonWrapper = SubmitButtonWrapper;